const selectors = {
  body: 'body',
  drawerWrappper: '[data-drawer]',
  drawerInner: '[data-drawer-inner]',
  underlay: '[data-drawer-underlay]',
  stagger: '[data-stagger-animation]',
  wrapper: '[data-header-transparent]',
  transparent: 'data-header-transparent',
  drawerToggle: 'data-drawer-toggle',
  focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
  mobileNav: '[data-mobile-nav]',
};

const classes = {
  isVisible: 'drawer--visible',
  isFocused: 'is-focused',
  headerStuck: 'js__header__stuck',
  mobileNavHidden: 'header__mobile__nav--hidden',
};

let sections = {};

class Drawer {
  constructor(el) {
    this.drawer = el;
    this.drawerWrapper = this.drawer.closest(selectors.drawerWrappper);
    this.drawerInner = this.drawer.querySelector(selectors.drawerInner);
    this.underlay = this.drawer.querySelector(selectors.underlay);
    this.wrapper = this.drawer.closest(selectors.wrapper);
    this.key = this.drawer.dataset.drawer;
    const btnSelector = `[${selectors.drawerToggle}='${this.key}']`;
    this.buttons = document.querySelectorAll(btnSelector);
    this.staggers = this.drawer.querySelectorAll(selectors.stagger);
    this.body = document.querySelector(selectors.body);
    this.mobileNav = document.querySelector(selectors.mobileNav);

    this.initWatchFocus = (evt) => this.watchFocus(evt);

    this.connectToggle();
    this.connectDrawer();
    this.closers();
    this.staggerChildAnimations();
  }

  connectToggle() {
    this.buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.drawer.dispatchEvent(
          new CustomEvent('theme:drawer:toggle', {
            bubbles: false,
          })
        );
      });
    });
  }

  connectDrawer() {
    this.drawer.addEventListener('theme:drawer:toggle', () => {
      if (this.drawer.classList.contains(classes.isVisible)) {
        this.drawer.dispatchEvent(
          new CustomEvent('theme:drawer:close', {
            bubbles: true,
          })
        );
      } else {
        this.drawer.dispatchEvent(
          new CustomEvent('theme:drawer:open', {
            bubbles: true,
          })
        );
      }
    });

    document.addEventListener('theme:drawer:close', this.hideDrawer.bind(this));
    document.addEventListener('theme:drawer:open', this.showDrawer.bind(this));
  }

  staggerChildAnimations() {
    this.staggers.forEach((el) => {
      const children = el.querySelectorAll(':scope > * > [data-animates]');
      children.forEach((child, index) => {
        child.style.transitionDelay = `${index * 50 + 10}ms`;
      });
    });
  }

  watchFocus(evt) {
    let drawerInFocus = this.wrapper.contains(evt.target);
    if (!drawerInFocus && this.body.classList.contains(classes.isFocused)) {
      this.hideDrawer();
    }
  }

  closers() {
    this.wrapper.addEventListener(
      'keyup',
      function (evt) {
        if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
          return;
        }
        this.hideDrawer();
        this.buttons[0].focus();
      }.bind(this)
    );

    this.underlay.addEventListener('click', () => {
      this.hideDrawer();
    });
  }

  showDrawer() {
    document.dispatchEvent(
      new CustomEvent('theme:drawer:close', {
        bubbles: false,
      })
    );

    this.buttons.forEach((el) => {
      el.setAttribute('aria-expanded', true);
      el.classList.add(classes.isVisible);
    });

    this.drawer.classList.add(classes.isVisible);
    this.drawer.querySelector(selectors.focusable).focus();
    this.wrapper.setAttribute(selectors.transparent, false);

    if (this.mobileNav) {
      this.mobileNav.classList.add(classes.mobileNavHidden);
    }

    document.addEventListener('focusin', this.initWatchFocus);
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: this.drawerInner}));
  }

  hideDrawer() {
    this.buttons.forEach((el) => {
      el.setAttribute('aria-expanded', true);
      el.classList.remove(classes.isVisible);
    });

    this.drawer.classList.remove(classes.isVisible);
    document.removeEventListener('focusin', this.initWatchFocus);

    if (!this.wrapper.classList.contains(classes.headerStuck)) {
      this.wrapper.setAttribute(selectors.transparent, theme.settings.transparentHeader);
    }

    if (this.mobileNav) {
      this.mobileNav.classList.remove(classes.mobileNavHidden);
    }

    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    document.dispatchEvent(new CustomEvent('theme:sliderule:close', {bubbles: false}));
  }
}

const drawer = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(selectors.drawerWrappper);
    els.forEach((el) => {
      sections[this.id].push(new Drawer(el));
    });
  },
};

export default drawer;
